const ONE_WAY = 'ONE_WAY'
const ROUND_TRIP = 'ROUND_TRIP'
const MULTI_DESTINATION = 'MULTI_DESTINATION'

const itineraryTypes = {
  ONE_WAY,
  ROUND_TRIP,
  MULTI_DESTINATION
}

export { itineraryTypes }
